/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Events_YetInputs */

const th_no_events_yet = /** @type {(inputs: No_Events_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่มีรายการแข่งขัน`)
};

const en_no_events_yet = /** @type {(inputs: No_Events_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No events yet.`)
};

const ja_no_events_yet = /** @type {(inputs: No_Events_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大会はまだありません。`)
};

const zh_no_events_yet = /** @type {(inputs: No_Events_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无赛事。`)
};

const es_no_events_yet = /** @type {(inputs: No_Events_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay eventos.`)
};

const pt_no_events_yet = /** @type {(inputs: No_Events_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum evento ainda.`)
};

const id_no_events_yet = /** @type {(inputs: No_Events_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada acara.`)
};

const fr_no_events_yet = /** @type {(inputs: No_Events_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun événement pour l’instant.`)
};

const tl_no_events_yet = /** @type {(inputs: No_Events_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala pang event.`)
};

const vi_no_events_yet = /** @type {(inputs: No_Events_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có sự kiện.`)
};

const ko_no_events_yet = /** @type {(inputs: No_Events_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 이벤트가 없습니다.`)
};

const de_no_events_yet = /** @type {(inputs: No_Events_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Events.`)
};

const ru_no_events_yet = /** @type {(inputs: No_Events_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Событий пока нет.`)
};

const tr_no_events_yet = /** @type {(inputs: No_Events_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Henüz etkinlik yok.`)
};

const it_no_events_yet = /** @type {(inputs: No_Events_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessun evento.`)
};

const pl_no_events_yet = /** @type {(inputs: No_Events_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie ma jeszcze wydarzeń.`)
};

const uk_no_events_yet = /** @type {(inputs: No_Events_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подій поки немає.`)
};

const hi_no_events_yet = /** @type {(inputs: No_Events_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी कोई आयोजन नहीं।`)
};

const ar_no_events_yet = /** @type {(inputs: No_Events_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد فعاليات بعد.`)
};

const ms_no_events_yet = /** @type {(inputs: No_Events_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada acara.`)
};

const bn_no_events_yet = /** @type {(inputs: No_Events_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এখনও কোনও আয়োজন নেই।`)
};

const zh_tw2_no_events_yet = /** @type {(inputs: No_Events_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚無賽事。`)
};

const zh_hk2_no_events_yet = /** @type {(inputs: No_Events_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚無賽事。`)
};

const ur_no_events_yet = /** @type {(inputs: No_Events_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابھی کوئی ایونٹ نہیں۔`)
};

const fa_no_events_yet = /** @type {(inputs: No_Events_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هنوز رویدادی نیست.`)
};

const sw_no_events_yet = /** @type {(inputs: No_Events_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna matukio bado.`)
};

const nl_no_events_yet = /** @type {(inputs: No_Events_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen evenementen.`)
};

/**
* | output |
* | --- |
* | "No events yet." |
*
* @param {No_Events_YetInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const no_events_yet = /** @type {((inputs?: No_Events_YetInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Events_YetInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_no_events_yet(inputs)
	if (locale === "ja") return ja_no_events_yet(inputs)
	if (locale === "zh") return zh_no_events_yet(inputs)
	if (locale === "es") return es_no_events_yet(inputs)
	if (locale === "pt") return pt_no_events_yet(inputs)
	if (locale === "id") return id_no_events_yet(inputs)
	if (locale === "fr") return fr_no_events_yet(inputs)
	if (locale === "tl") return tl_no_events_yet(inputs)
	if (locale === "vi") return vi_no_events_yet(inputs)
	if (locale === "ko") return ko_no_events_yet(inputs)
	if (locale === "de") return de_no_events_yet(inputs)
	if (locale === "ru") return ru_no_events_yet(inputs)
	if (locale === "tr") return tr_no_events_yet(inputs)
	if (locale === "it") return it_no_events_yet(inputs)
	if (locale === "pl") return pl_no_events_yet(inputs)
	if (locale === "uk") return uk_no_events_yet(inputs)
	if (locale === "hi") return hi_no_events_yet(inputs)
	if (locale === "ar") return ar_no_events_yet(inputs)
	if (locale === "ms") return ms_no_events_yet(inputs)
	if (locale === "bn") return bn_no_events_yet(inputs)
	if (locale === "zh-TW") return zh_tw2_no_events_yet(inputs)
	if (locale === "zh-HK") return zh_hk2_no_events_yet(inputs)
	if (locale === "ur") return ur_no_events_yet(inputs)
	if (locale === "fa") return fa_no_events_yet(inputs)
	if (locale === "sw") return sw_no_events_yet(inputs)
	if (locale === "nl") return nl_no_events_yet(inputs)
	return en_no_events_yet(inputs)
});